export default {
    // 获取用户信息_钟军
    getTeacherById(params) {
        return app.http.ajax({
            method: "get",
            url: "/cs-crm/teacher/get",
            params: params,
        });
    },
    // 邀请_钟军
    registerInvite(params) {
        return app.http.ajax({
            method: "post",
            url: "/cs-crm/teacher/invite",
            params: params,
        });
    },
    // 获取验证码接口  /login/login 钟军
    codeSms(params) {
        return app.http.ajax({
            method: "get",
            url: "/cs-crm/user/sendSmsCode",
            params: params
        });
    },
    // 通用登录_钟军
    userLogin(params) {
        return app.http.ajax({
            method: "post",
            url: "/cs-crm/user/login",
            params: params,
        });
    },
    // 手机号密码登录（机构端）
    loginByPhonePwd(params) {
        return app.http.ajax({
            method: "post",
            url: "/cs-crm/teacher/loginByPhonePwd",
            params: params,
        }); 
    },
};